import { request } from 'ice';
import { INBOUNDSERVICE } from '@/const';

// 入库面板tip
async function getEffect(data) {
  return await request({
    url: `${INBOUNDSERVICE}/efficiencyBoard/getWarehouseEfficiency`,
    method: 'POST',
    data,
  });
}

export { getEffect };
